module.exports = __webpack_public_path__ + "static/media/公路隧道桥梁融雪除冰1.f6c48b9e.jpg";